import React from 'react';
import { Header } from './components/layout/Header';
import { Sidebar } from './components/layout/Sidebar';
import { Canvas } from './components/canvas/Canvas';
import { PanelTabs } from './components/panels/PanelTabs';
import { EmptyState } from './components/layout/EmptyState';
import { useKeyboardShortcuts, useHistoryInit, useProjectLoader } from './hooks';
import { useCreativeStore } from './stores';

export default function App() {
  // Initialize unified history system
  useHistoryInit();

  // Enable keyboard shortcuts
  useKeyboardShortcuts();

  // Load creative data when creative selection changes
  useProjectLoader();

  const currentCreativeId = useCreativeStore((s) => s.currentCreativeId);
  const isInitialized = useCreativeStore((s) => s.isInitialized);

  // Show canvas only when a creative is selected
  const showCanvas = isInitialized && currentCreativeId !== null;

  return (
    <div className="flex flex-col h-screen overflow-hidden">
      <Header />
      <div className="flex flex-1 overflow-hidden">
        <Sidebar />
        <main className="flex-1 relative overflow-hidden">
          {showCanvas ? (
            <>
              <Canvas />
              <PanelTabs />
            </>
          ) : (
            <EmptyState />
          )}
        </main>
      </div>
    </div>
  );
}
